module.exports = __webpack_public_path__ + "img/sc.eb087eb3.svg";